import React, { useCallback } from 'react';
import {
  eInternalOrderStatusWithoutDeprecatedValues,
  prettyInternalOrderStatusWithoutDeprecatedValues,
} from '../../../../ui-toolkit/enums/eInternalOrderStatus';
import { useField } from 'formik';
import { Combobox, FormField, FormHelp, Label } from '@zillow/constellation';
import { StatusExclusionFilter } from './StatusExclusionFilter';

const statusOptions = Object.values(eInternalOrderStatusWithoutDeprecatedValues).map((status) => ({
  label: prettyInternalOrderStatusWithoutDeprecatedValues[status],
  value: status,
  id: status,
}));

export const StatusFilter: React.FC = () => {
  const [statusesField, statusesMeta, statusesHelpers] = useField<string[]>({ name: 'orderStatuses' });
  const [excludeCanceledField, ,] = useField<boolean>({
    name: 'excludeCanceledOrders',
  });
  const [excludeInactiveField, ,] = useField<boolean>({
    name: 'excludeInactiveOrders',
  });

  const handleChange = useCallback(
    (nextValue: any) => {
      statusesHelpers.setValue(nextValue);
    },
    [statusesHelpers]
  );

  return (
    <>
      <FormField
        label={<Label>Order Status</Label>}
        control={
          <Combobox
            value={statusesField.value}
            options={statusOptions}
            onChange={handleChange}
            autoCompleteBehavior="automatic"
            multiple
            showLabelForValue
            limitTagsShown={3}
            disabled={excludeCanceledField.value || excludeInactiveField.value}
          />
        }
        error={!!statusesMeta.error}
        description={<FormHelp>{statusesMeta.error}</FormHelp>}
      />
      <StatusExclusionFilter />
    </>
  );
};
